import { Component, h } from '@stencil/core';

@Component({
  tag: 'icon-chevron-down',
  shadow: true,
})
export class IconChevronUp {
  render() {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="10" fill="white" />
        <mask id="mask0_4_151" maskUnits="userSpaceOnUse" x="4" y="6" width="13" height="8">
          <path
            d="M5.60963 6.28416C5.24881 5.91279 4.65534 5.90433 4.28408 6.26525C3.91282 6.62617 3.90435 7.2198 4.26518 7.59117L9.4484 12.9258C9.81655 13.3047 10.4248 13.3047 10.7929 12.9258L15.9749 7.59108C16.3357 7.21968 16.3271 6.62604 15.9558 6.26517C15.5845 5.90429 14.9911 5.91283 14.6303 6.28424L10.1205 10.9269L5.60963 6.28416Z"
            fill="#0799F8"
          />
        </mask>
        <g mask="url(#mask0_4_151)">
          <rect width="20" height="20" fill="#0799F8" />
        </g>
      </svg>
    );
  }
}
